import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
function GraziePage() {
  useEffect(() => {
    // Evento Purchase Meta Pixel - si attiva quando l'utente arriva su questa pagina
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 197,
        currency: 'EUR',
        content_name: 'Report Incentivi Completo',
        content_type: 'product'
      });
    }
    // Evento CompletePayment TikTok Pixel
    if (window.ttq) {
      window.ttq.track('CompletePayment', {
        value: 197,
        currency: 'EUR',
        content_name: 'Report Incentivi Completo',
        content_type: 'product'
      });
    }
    // Scroll in cima alla pagina
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f5e9 100%)',
      padding: '40px 20px'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 8px 32px rgba(26,86,219,0.10)',
        padding: '48px 40px',
        maxWidth: 560,
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Icona successo */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #22c55e, #16a34a)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          fontSize: 40
        }}>
          ✓
        </div>
        <h1 style={{
          fontSize: 28,
          fontWeight: 800,
          color: '#1a56db',
          marginBottom: 12
        }}>
          Grazie per il tuo acquisto!
        </h1>
        <p style={{
          fontSize: 16,
          color: '#4b5563',
          marginBottom: 8,
          lineHeight: 1.6
        }}>
          Il tuo pagamento è stato completato con successo.
        </p>
        <p style={{
          fontSize: 16,
          color: '#4b5563',
          marginBottom: 32,
          lineHeight: 1.6
        }}>
          Il tuo <strong>Report Incentivi Completo</strong> è ora disponibile nella tua area personale.
          Riceverai anche una email di conferma con tutti i dettagli.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link
            to="/report"
            style={{
              background: 'linear-gradient(135deg, #1a56db, #1e40af)',
              color: '#fff',
              padding: '14px 28px',
              borderRadius: 8,
              textDecoration: 'none',
              fontWeight: 700,
              fontSize: 16,
              display: 'inline-block'
            }}
          >
            Visualizza il tuo Report
          </Link>
          <Link
            to="/dashboard"
            style={{
              background: '#f3f4f6',
              color: '#374151',
              padding: '14px 28px',
              borderRadius: 8,
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 16,
              display: 'inline-block'
            }}
          >
            Vai alla Dashboard
          </Link>
        </div>
        <p style={{
          marginTop: 24,
          fontSize: 13,
          color: '#9ca3af'
        }}>
          Hai bisogno di aiuto? Contattaci a{' '}
          <a href="mailto:info@verificaincentivi.it" style={{ color: '#1a56db' }}>
            info@verificaincentivi.it
          </a>
        </p>
      </div>
    </div>
  );
}
export default GraziePage;
